import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "../../../api/axios";
import MetaDecorator from "../../UtilsComponents/MetaDecorator";
import { useQuery } from "@tanstack/react-query";
import { useSessionStorage } from "../../../CustomHooks/useSessionStorage";
import { Box } from "@mui/material";
import { LoadingComponent } from "./MainSurveyComponensts/LoadingComponent";

export function NewSurvey() {
    let [id] = useState(useParams().id);
    const intl = useIntl();
    let [customer] = useState(useParams().customer);
    customer = customer.toLowerCase();
    const [server] = useState(process.env.REACT_APP_SERVER);
    const queryParams = new URLSearchParams(window.location.search);
    const number = queryParams.get("number");
    const Cname = queryParams.get("name");
    const customerId = queryParams.get("cId");
    const code = queryParams.get("code");//this is invoice
    const email = queryParams.get("email");
    const survey = queryParams.get("survey");
    // const [customers, setCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");
    const [waitMsg, setWaitMsg] = useState("");
    const [surveyNumber, setSurveyNumber] = useSessionStorage("surveyNumber", 0);
    const [countdown, setCountdown] = useState(10 * surveyNumber);
    const [surveyFound, setSurveyFound] = useState(false);
    const [values, setValues] = useState({
        display_name: Cname ? Cname : null,
        phone: number ? number : null,
        email: email ?? null,
        survey_id: null,
        identification_number: customerId ?? null,
        invoice: code ?? null,
        status: 3,
        store: null,
        city: null,
        sent_method: "WEB"
    });
    // Validate customer

    const fontColor = '#868688'
    const headerBackground = "whitesmoke";
    const bodyBackground = "whitesmoke";
    // change the color of the body background
    document.body.style.backgroundColor = bodyBackground;

    const getCustomerData = async () => {
        const response = await axios.get(`customer/${id}?customer=${customer}`);
        if (!response.data?.text) {
            return response.data;
        }
    }

    const { data: customers, isLoading: isLoadingCustomer } = useQuery({
        queryKey: [customer, id],
        queryFn: getCustomerData,
        onError: (error) => {
            if (error.response?.status === 404) {
                // console.error("No se encontró el cliente");
                setErrorMsg(intl.formatMessage({ id: "survey.not.found.msg" }));
            } else if (error.response?.status === 409) {
                setErrorMsg(intl.formatMessage({ id: "survey.end.trial.msg" }));
            }
            else {
                console.error(error.message);
            }
        },
        refetchOnWindowFocus: false,
        retry: false,
    });

    const getCustomerStoreData = async () => {
        const response = await axios.get(`store/${id}?customer=${customer}&survey=${survey}`);
        if (!response.data?.text) {
            const store = response.data;
            const capitalizeFirstLetter = str => (str && str.split(" ").map(subStr => subStr[0].toUpperCase() + subStr.slice(1)).join(" ")) || "";
            let obj = {};
            if (store) {
                setValues(v => ({
                    ...v,
                    store: store[0]?.store_code,
                    store_id: store[0]?.store_id,
                    city: capitalizeFirstLetter(store[0]?.city.toLowerCase()),
                    survey_id: store[0]?.survey_id
                }));
                obj[store[0]?.customerName] = response.data[0]?.survey_id;
            }
            return obj;
        }
    }

    const { data: customerStore, isLoading: isLoadingCustomerStore } = useQuery({
        queryKey: [`${customer}Store`, id],
        queryFn: getCustomerStoreData,
        onError: (error) => {
            if (error.response?.status === 404) {
                // console.error("No se encontró el cliente");
                setErrorMsg(intl.formatMessage({ id: "survey.not.found.msg" }));
            } else if (error.response?.status === 409) {
                setErrorMsg(intl.formatMessage({ id: "survey.end.trial.msg" }));
            }
            else {
                console.error(error.message);
            }
        },
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        setIsLoading(isLoadingCustomer && isLoadingCustomerStore);
    }, [isLoadingCustomer, isLoadingCustomerStore]);

    useEffect(() => {
        setSurveyFound(customerStore || customers);
    }, [customers, customerStore]);

    useEffect(() => {
        if (customers) {
            if (customer !== "hermeco") {
                if (Object.keys(customers).length > 0) {
                    setValues(v => ({
                        ...v,
                        survey_id: customers[Object.keys(customers)[0]][0]
                    }));
                }
            }
        }
    }, [customers, customer, id]);

    useEffect(() => {
        if (countdown === 0) {
            setWaitMsg("")
        }
        if (countdown === 0 || isLoading || !surveyFound) return;
        if (surveyNumber > 0) {
            setWaitMsg(
                <FormattedMessage
                    id="new.survey.wait.msg"
                    defaultMessage={'Por favor espere unos segundos para continuar'}
                    values={{ countdown }}
                />
            );
            const timer = setTimeout(() => {
                setCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000); // Decrease the countdown every 1000ms (1 second)
            // Clean up the timer when the component is unmounted or countdown reaches 0
            return () => clearTimeout(timer);
        }
    }, [surveyNumber, countdown, isLoading, surveyFound]);




    useEffect(() => {
        if (surveyFound && countdown === 0) {
            setSurveyNumber(parseInt(1));//si se quiere cambiar el tiempo de espera sumar +surveyNumber
            const customerName = customers ? Object.keys(customers)[0] : Object.keys(customerStore)[0];
            fetch(`${server}users?customer=${customerName}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(values)
            }).then(async (res) => {
                const data = await res.json();
                //Send to main survey
                if (data?.id) {
                    window.location.href = `/survey/${customerName}/${data.id}`;
                } else {
                    setWaitMsg(data.text)
                }
            }).catch((err) => {
                console.error(err);
                // Sentry.captureException(err);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, server, values, surveyFound, countdown]);

    if (isLoading) {
        return (
            <LoadingComponent />
        );
    }
    if (!surveyFound) {
        return (
            <LoadingComponent
                errorMsg={errorMsg}
                styles={{ padding: "20rem 0px" }}
                fontStyles={{ color: fontColor }}
            />
        );
    }
    return (
        <>
            <MetaDecorator
                title={`NS | ${customer} | ${id}`}
                description={"Para nosotros es muy importante conocer tu opinión sobre nuestros productos y servicios. Por favor, ayúdanos a mejorar respondiendo esta encuesta."}
                imageUrl={"/images/7Bytes.png"}
                imageAlt={"7Bytes"}
                path={window.location.pathname}
            />
            <Box
                className="RegularMadeTommy"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    backgroundColor: headerBackground,
                    padding: "0rem 5rem",
                }}
            >
                {
                    waitMsg &&
                    <h3 className="text-center" style={{ color: fontColor }}>
                        {waitMsg}
                    </h3>
                }
                {
                    !waitMsg &&
                    <h3 style={{ color: fontColor }}>
                        <FormattedMessage
                            id="redirecting.msg"
                            defaultMessage={'Redireccionando...'}
                        />
                    </h3>
                }
            </Box>
        </>
    )
}